import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * query batch superbill by unique id for email
 */
export default async function queryBatchSuperbillByUniqueIdForEmail(
  uniqueIdForEmail: string | number,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/batch_superbill/unique_id_for_email/${uniqueIdForEmail}`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
